import React, { Component } from 'react';
import {NavLink, Link} from 'react-router-dom';


class Sidebar extends Component {

   constructor(props) {
    super(props);

     this.state={

     }
  }

  renderMarksheet()
  {
    const _this = this;
      if(_this.props.staff_details.core_details.Lecturer == 1)
      {
          return(
            <li className="nav-item ">
              <NavLink className="nav-link" to="/staff_ui/upload_marks">
                <i className="material-icons">description</i>
                <p>Upload Marks</p>
              </NavLink>
          </li>

          );
      }
      else{
          return null;
      }
  }

  renderLeaveApplication()
  {
    const _this = this;
      if(_this.props.staff_details.core_details.Lecturer == 1 )
      {
        return null; 
      }
      else{
         
          return(
            <li className="nav-item ">
              <NavLink className="nav-link" to="/staff_ui/leave">
                <i className="material-icons">description</i>
                <p>Apply for Leave</p>
              </NavLink>
          </li>
          );
      }
  }

  renderPayslip()
  {
    const _this = this;
    

      if(_this.props.staff_details.core_details.Lecturer == 1  )
      {
        return null; 
      }
      else{
          
          return(
            <li className="nav-item ">
            <NavLink className="nav-link" to="/staff_ui/payslip">
              <i className="material-icons">receipt</i>
              <p>PaySlip</p>
            </NavLink>
          </li>

          );
      }
  }


  render() {
    const _this=this;

    console.log("Staff Details SB ", _this.props.staff_details);

    return (

        <div className="sidebar" data-color="azure" data-background-color="white" data-image="/img/sidebar-1.jpg">

      <div className="logo">
        <Link to="#" className="simple-text logo-normal text-center">
          TUC - STAFF PORTAL
        </Link>
      </div>
      <div className="sidebar-wrapper">
        <ul className="nav">
          <li className="nav-item">
            <NavLink className="nav-link" to="/staff_ui/home">
              <i className="material-icons">person</i>
              <p>My Profile</p>
            </NavLink>
          </li>
          {_this.renderPayslip()}
          {_this.renderLeaveApplication()}
          {_this.renderMarksheet()}
          
          


        </ul>
      </div>
    <div className="sidebar-background"></div></div>





    );
  }




}

export default Sidebar;
